<template>
    <div class="w-responsive mx-auto vh-0" >
        <div class="w-100 p-1 header" style="background:#04488e;height:100%;" >
            <h5 class="align-baseline" style="color:white;font-size: 13px"><i class="fa fa-user-clock fa-2x"></i>&nbsp; Reserva <strong>Online</strong> de <strong>Horas Médicas</strong></h5>
        </div>
         <div  class="min-vh-100  border"  style="background:#F7F7F7" >

            <router-view></router-view>
        </div>
    </div>
</template>

<script>

    export default {
        created() {

        }
    }
</script>

<style scoped>
    .w-responsive{
        padding: 0px;
        transform: translateY(-0%);
    }
</style>